// extracted by mini-css-extract-plugin
export default {"symbol":"styles_symbol__hNQyJ","symbol_wrap":"styles_symbol_wrap__vJIEs","popup":"styles_popup__AmNQk"};